import * as React from "react"

import { Chip, Theme, useTheme } from "@mui/material"

import { alpha as MuiAlpha } from "@mui/material"
import { useTranslation } from "react-i18next"
import Tag from "../tag"

interface IStatusBoxProps {
  status?: string
  alpha?: number
  label?: string
}

const StatusBox: React.FunctionComponent<IStatusBoxProps> = ({
  status,
  alpha = 0.12,
  label,
}) => {
  // Getting Translation object
  const { t } = useTranslation(["common"])
  // Getting mui theme
  const theme = useTheme<Theme>()
  // color box status
  let colorStatus: string
  // color text status
  let colorText: string
  // text status
  let textStatus: string = ""

  switch (status) {
    case "success":
    case "seeding": {
      colorText = alpha
        ? theme.palette.success.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.success.main, alpha)
      textStatus = label || t("common:paid")
      break
    }
    // case "seeding": {
    //   colorText = theme.palette.success.main
    //   colorStatus = '#a6e0ff'
    //   // colorStatus = alpha(theme.palette.success.main, 0.12)
    //   textStatus = t("common:seeding")
    //   break
    // }

    case "published":
      colorText = '#035d9b'

      colorStatus = '#a6e0ff';
      textStatus = t("common:property_status_published")
      break

    case "soon": {
      colorText = 'white'
      colorStatus = '#5b738b'
      // colorStatus = alpha(theme.palette.success.main, 0.12)
      textStatus = t("common:soon")
      break
    }
    case "Enabled": {
      colorText = alpha
        ? theme.palette.success.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.success.main, alpha)
      textStatus = label || t("common:enabled")
      break
    }
    case "paid": {
      colorText = alpha
        ? theme.palette.success.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.success.main, alpha)
      textStatus = label || t("common:paid")
      break
    }
    case "sent": {
      colorText = alpha
        ? theme.palette.success.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.success.main, alpha)
      textStatus = label || t("common:sent")
      break
    }
    case "error": {
      colorText = alpha ? theme.palette.error.main : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.error.main, alpha)
      textStatus = label || t("common:error")
      break
    }
    case "unpaid": {
      colorText = alpha ? theme.palette.error.main : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.error.main, alpha)
      textStatus = label || t("common:unpaid")
      break
    }
    case "failed": {
      colorText = alpha ? theme.palette.error.main : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.error.main, alpha)
      textStatus = label || t("common:didnt_send")
      break
    }
    case "disabled":
    case "Disabled": {
      colorText = alpha ? theme.palette.error.main : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.error.main, alpha)
      textStatus = label || t("common:disabled")
      break
    }
    case "sending": {
      colorText = alpha
        ? theme.palette.primary.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.primary.main, alpha)
      textStatus = label || t("common:sending")
      break
    }
    case "planned": {
      colorText = alpha ? theme.palette.info.main : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.info.main, alpha)
      textStatus = label || t("common:planned")
      break
    }
    case "warning": {
      colorText = alpha
        ? theme.palette.warning.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.warning.main, alpha)
      textStatus = label || t("common:paying")
      break
    }
    case "pending": {
      colorText = theme.palette.warning.main
      colorStatus = MuiAlpha(theme.palette.warning.light, alpha)
      textStatus = label || t("common:paying")
      break
    }
    case "Pending": {
      colorText = theme.palette.warning.main
      colorStatus = MuiAlpha(theme.palette.warning.light, alpha)
      textStatus = label || t("common:pending")
      break
    }
    case "info": {
      colorText = alpha
        ? theme.palette.warning.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.warning.main, alpha)
      textStatus = label || t("common:pending")
      break
    }
    case "rejected":
    case "Rejected":
      colorText = alpha ? theme.palette.error.main : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.error.main, alpha)
      textStatus = label || t("common:rejected")
      break
    case "Accepted": {
      colorText = alpha
        ? theme.palette.success.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.success.main, alpha)
      textStatus = label || t("common:accepted")
      break
    }
    case "suspended": {
      colorText = alpha ? theme.palette.error.main : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.error.main, alpha)
      textStatus = label || t("common:suspended")
      break
    }
    case "verified": {
      colorText = theme.palette.success.main
      colorStatus = MuiAlpha(theme.palette.success.light, alpha)
      textStatus = label || t(`common:transaction_verified`)
      break
    }
    default: {
      colorText = alpha
        ? theme.palette.primary.main
        : theme.palette.common.white
      colorStatus = MuiAlpha(theme.palette.primary.main, alpha)
      textStatus = label || status
      break
    }
  }

  if (alpha === 1) {
    colorText = "#fff !important"
  }



  return (
    <>
      {/* <Chip
        label={textStatus}
        sx={{ background: colorStatus, color: colorText }}
      /> */}
      <Tag
        title={t(`common:property_status_${status}` as any)}
        color={status}
      />

    </>

  )
}

export default StatusBox
